import { getProgressList, progressDownloadFile } from "./PmGIPPMPLI01/GIPPMPLI01Reducer";
import { getProgressManagementInfo, saveProgressManagementInfo } from "./PmGIPPMPMF01/GIPPMPMF01Reducer";

export const ipReducer = {
    getProgressList,
    getProgressManagementInfo,
    saveProgressManagementInfo,
    progressDownloadFile
};
